import React from 'react'
import { CurecallLogoSecondaryWhite } from '@honestica/curecall-ui'
import { useTranslation } from 'react-i18next'
import { twMerge } from 'src/utils/tw-merge.util'

interface LayoutProps {
  children: React.ReactNode
  isError?: boolean
}

const AuthLayout = ({ children, isError }: LayoutProps) => {
  const { t } = useTranslation()
  const BubbleWhite = ({ className, size = 'lg' }: any) => {
    return (
      <div
        className={twMerge(
          'c-absolute c--z-10',
          size === 'lg' && 'c-h-[334.98px] c-w-[334.98px]',
          size === 'md' && 'c-h-[271.26px] c-w-[271.26px]',
          size === 'sm' && 'c-h-[238.02px] c-w-[238.02px]',
          className,
        )}
      >
        <img
          src="/assets/img/bubble_white.svg"
          alt=""
          style={{
            width: '100%',
            height: 'auto',
          }}
        />
      </div>
    )
  }

  return (
    <main className="c-m-0 c-p-0 c-h-screen">
      {/* mid size & big size screen */}
      <div className="c-hidden sm:c-relative sm:c-z-0 sm:c-block sm:c-h-screen sm:c-overflow-hidden sm:c-bg-gradient-03 c-max-w-full">
        <div className="c-flex c-h-full c-flex-row c-justify-around 2xl:c-justify-center 2xl:c-space-x-28 c-items-center">
          <div className="xs:c-hidden xl:c-w-2/6 lg:c-flex-col lg:c-text-center lg:c-flex">
            <div className="c-w-40">
              <img src="/assets/img/logo_with_name.png" alt={t('common.curecall-logo')} width={163} />
            </div>
            <h1 className="c-mb-10 c-mt-5 c-whitespace-pre-wrap c-text-3xl c-font-bold c-text-primary-1000">
              {isError ? t('common.error.generic') : t('common.build-tomorrow-followups')}
            </h1>
            <div>
              <img src={isError ? '/assets/img/logo_error.png' : '/assets/img/doctor.svg'} alt="" />
            </div>
          </div>
          <div className="xs:c-w-full  xl:c-w-2/6">{children}</div>
        </div>
        <BubbleWhite className="c--left-42 c-top-32 c--rotate-[190deg]" size="md" />
        <BubbleWhite className="c--top-52 c-left-1/4 c--rotate-[37deg]" size="lg" />
        <BubbleWhite className="c-right-[600px] c-top-2/4 c--rotate-[72deg]" size="sm" />
        {!isError && (
          <div className="c-absolute c--bottom-1 c--z-10 c-w-full c--rotate-[-1deg]">
            <img
              src="/assets/img/waves.svg"
              alt=""
              style={{
                maxWidth: '100%',
                height: 'auto',
              }}
            />
          </div>
        )}
      </div>

      {/* small size screen */}
      <div className="xs:c-flex xs:c-h-full xs:c-flex-col sm:c-hidden">
        <div className="c-relative c-z-0 c-flex c-flex-shrink-0 c-overflow-hidden c-bg-gradient-to-r c-from-[#33CCCC] c-to-[#8888FC] c-py-6">
          <div className="c-ml-10">
            <CurecallLogoSecondaryWhite className="c-w-64" />
          </div>
          <BubbleWhite className="c--top-5 c--right-6 c--rotate-[333deg]" size="md" />
        </div>
        {children}
      </div>
    </main>
  )
}

export { AuthLayout }
